<div class="shadow-xl py-2.5 px-4 fixed right-0 bottom-0 bg-edu-white mb-2.5 mr-2.5 z-10" *ngIf="visible">
	<img alt="Fechar" src="./assets/icons/close.svg" class="ml-auto cursor-pointer" role="button" *ngIf="withCloseButton" (click)="closed.emit()" />
	<ng-content></ng-content>
</div>
